/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  getOnboardingInfo() {
    return axios.get(`${this.url}/get_onboarding_info`);
  }
}

export default new AccountAPI();
